import { withNamespace, NamespaceShape } from '@ux/namespace-component';
import Base from './toggle';
import React from 'react';
import rip from 'rip-out';

/**
 * Class representing a 2-state switch.
 *
 * @displayName Toggle (web)
 * @class Toggle
 * @public
 */
export class Toggle extends Base {
  render() {
    let { type, onChange, onKeyDown, hideLabel, ...props  } = this.props;
    const { label } = this.props;
    const checked = !!('checked' in props ? props.checked : this.state.checked);
    const id = this.id('label');

    onChange = onChange || this.onChange;
    onKeyDown = onKeyDown || this.onKeyDown;
    type = ~Base.allowedTypes.indexOf(type) ? type : Base.allowedTypes[0];

    const className = this.namespace(this.classNames('ux-toggle', {
      disabled: props.disabled,
      small: props.small
    }));

    props = rip(props, 'small', 'namespace');

    return (
      <label htmlFor={ id } className={ className }>
        <input { ...props }
          type={ type }
          checked={ checked }
          className={ this.namespace('ux-toggle-checkbox') }
          onChange={ onChange }
          onKeyDown={ onKeyDown }
          id={ id }
          tabIndex='0'
        />
        <span className={ this.namespace('ux-toggle-bg') }></span>
        <span className={ this.namespace('ux-toggle-handle') }></span>
        { !hideLabel && label && <span className={ this.namespace('ux-toggle-message') }>{ label }</span> }
      </label>
    );
  }
}

/**
 * Inherit the propTypes from the Namespace, as well as our base class. We
 * don't want to add these shapes to our base class as it doesn't need
 * any namespace functionality.
 *
 * @type {Object}
 * @public
 */
Toggle.propTypes = {
  ...NamespaceShape,
  ...Base.propTypes
};

export default withNamespace(Toggle);



// WEBPACK FOOTER //
// ./node_modules/@ux/toggle/index.js